(() => {
  const initialize = () => {
    document.querySelectorAll('[data-fl-navigation]').forEach(nav => {
      if (nav.dataset.flReady) return;
      nav.dataset.flReady = 'true';
      const menus = Array.from(nav.querySelectorAll('details'));
      const close = except => menus.forEach(menu => { if (menu !== except) menu.open = false; });
      menus.forEach(menu => menu.addEventListener('toggle', () => { if (menu.open) close(menu); }));
      nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = menus.find(menu => menu.open);
        if (open) { event.preventDefault(); close(); open.querySelector('summary').focus(); }
      });
      document.addEventListener('click', event => { if (!nav.contains(event.target)) close(); });
      document.addEventListener('focusin', event => { if (!nav.contains(event.target)) close(); });
      window.matchMedia('(max-width: 768px)').addEventListener('change', () => close());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
